export default "-- ClickBench Q19\nselect userid\nfrom hits\nwhere userid = 435090932899640449;";